import React from "react";
import "../Shopidy/CategoryView.css";
const MiddleBannerView = ({ data }) => {
  return (
    <div className="category-banner">
      {data?.length > 0 &&
        data.map((img, index) => (
          <img
            key={index}
            src={img?.image__image || img?.image}
            alt="Category Banner"
            height={150}
            width={600}
            className="middle_banner"
          />
        ))}
    </div>
  );
};
export { MiddleBannerView };
